// 模拟器开始下载
export const APKS_NT_SIM_DL_START = 'APKS_NT_SIM_DL_START';
// 模拟器下载进度
export const APKS_NT_SIM_DL_PROGRESS = 'APKS_NT_SIM_DL_PROGRESS';
// 模拟器下载完成
export const APKS_NT_SIM_DL_DONE = 'APKS_NT_SIM_DL_DONE';
// 模拟器开始安装
export const APKS_NT_SIM_INSTALL = 'APKS_NT_SIM_INSTALL';
// 模拟器安装完成
export const APKS_NT_SIM_INSTALL_DONE = 'APKS_NT_SIM_INSTALL_DONE';
// 虚拟机开始启动
export const APKS_NT_VM_RUN = 'APKS_NT_VM_RUN';
// 虚拟机桌面已启动
export const APKS_NT_VM_DESKTOP = 'APKS_NT_VM_DESKTOP';
// 模拟器准备阶段开始
export const APKS_NT_SIM_PREPARE = 'APKS_NT_SIM_PREPARE';
// 模拟器准备阶段结束通知
export const APKS_NT_SIM_PREPARE_DONE = 'APKS_NT_SIM_PREPARE_DONE';
// 开始下载apk
export const APKS_NT_DL_START = 'APKS_NT_DL_START';
// 下载apk进度
export const APKS_NT_DL_PROGRESS = 'APKS_NT_DL_PROGRESS';
// 下载apk完成
export const APKS_NT_DL_DONE = 'APKS_NT_DL_DONE';
// 开始安装apk
export const APKS_NT_INSTALL_START = 'APKS_NT_INSTALL_START';
// 结束安装apk
export const APKS_NT_INSTALL_DONE = 'APKS_NT_INSTALL_DONE';
// 通知apk下载安装已取消
export const APKS_NT_INSTALL_CANCEL = 'APKS_NT_INSTALL_CANCEL';
// 开始卸载apk
export const APKS_NT_UNINSTALL_START = 'APKS_NT_UNINSTALL_START';
// 结束卸载apk
export const APKS_NT_UNINSTALL_DONE = 'APKS_NT_UNINSTALL_DONE';
// 启动apk运行
export const APKS_NT_RUN_START = 'APKS_NT_RUN_START';
// apk运行结果
export const APKS_NT_RUN_DONE = 'APKS_NT_RUN_DONE';
// 获取安卓和PC本地安装列表
export const APKS_PC_NT_UPGRADE_LIST = 'APKS_PC_NT_UPGRADE_LIST';
// 模拟器开始更新安装
export const APKS_NT_SIM_UPGRADE = 'APKS_NT_SIM_UPGRADE';
// 模拟器更新安装完成
export const APKS_NT_SIM_UPGRADE_DONE = 'APKS_NT_SIM_UPGRADE_DONE';

// 客户端的通知消息名称汇总
export const APKS_NT_STATUS = [
  APKS_NT_SIM_DL_START,
  APKS_NT_SIM_DL_PROGRESS,
  APKS_NT_SIM_DL_DONE,
  APKS_NT_SIM_INSTALL,
  APKS_NT_SIM_INSTALL_DONE,
  APKS_NT_VM_RUN,
  APKS_NT_VM_DESKTOP,
  APKS_NT_SIM_PREPARE,
  APKS_NT_SIM_PREPARE_DONE,
  // APKS_NT_DL_START,
  // APKS_NT_DL_PROGRESS,
  // APKS_NT_DL_DONE,
  // APKS_NT_INSTALL_START,
  // APKS_NT_INSTALL_DONE,
  // APKS_NT_INSTALL_CANCEL,
  APKS_NT_UNINSTALL_START,
  APKS_NT_UNINSTALL_DONE,
  APKS_NT_RUN_START,
  APKS_NT_RUN_DONE,
  APKS_PC_NT_UPGRADE_LIST,
  APKS_NT_SIM_UPGRADE,
  APKS_NT_SIM_UPGRADE_DONE,
];

// 模拟器状态
export const SIM_PREPARING = 100; // 模拟器准备中
export const SIM_DOWNLOAD_ING = 101; // 模拟器下载
export const SIM_DOWNLOAD_FINISHED = 103; // 模拟器下载完成
export const SIM_DOWNLOAD_FAILED = 104; // 模拟器下载失败
export const SIM_INSTALL_ING = 105; // 模拟器安装中
export const SIM_INSTALL_FINISHED = 106; // 模拟器安装完成
export const SIM_INSTALL_FAILED = 107; // 模拟器安装失败
export const SIM_DOWNLOAD_CANCELED = 108; // 模拟器安装取消
export const SIM_VM_RUN = 109; // 模拟器虚拟机开始启动
export const SIM_VM_DESKTOP = 110; // 模拟器虚拟机桌面已启动
export const SIM_VM_DESKTOP_FAILED = 111; // 模拟器虚拟机桌面已启动失败
export const SIM_PREPARE = 112; // 模拟器准备阶段开始
export const SIM_PREPARE_FAILED = 113; // 模拟器准备阶段失败结束通知
export const SIM_PREPARE_DONE = 114; // 模拟器准备阶段成功结束通知
export const SIM_UPDATE_INSTALL_ING = 150; // 模拟器升级安装中
export const SIM_UPDATE_INSTALL_FINISHED = 151; // 模拟器升级安装完成
export const SIM_UPDATE_INSTALL_FAILED = 152; // 模拟器升级安装失败

// 模拟器所有状态集合
export const ALL_SIM_STATUS = [
  SIM_PREPARING,
  SIM_DOWNLOAD_ING,
  SIM_DOWNLOAD_FINISHED,
  SIM_DOWNLOAD_FAILED,
  SIM_INSTALL_ING,
  SIM_INSTALL_FINISHED,
  SIM_INSTALL_FAILED,
  SIM_DOWNLOAD_CANCELED,
  SIM_VM_RUN,
  SIM_VM_DESKTOP,
  SIM_VM_DESKTOP_FAILED,
  SIM_PREPARE,
  SIM_PREPARE_DONE,
  SIM_PREPARE_FAILED,
  SIM_UPDATE_INSTALL_ING,
  SIM_UPDATE_INSTALL_FINISHED,
  SIM_UPDATE_INSTALL_FAILED,
];

// 系统弹出模拟器提示弹框的，模拟器状态集合
export const SIM_STATUS_POP_SHOW = [
  SIM_PREPARING,
  SIM_DOWNLOAD_ING,
  SIM_DOWNLOAD_FINISHED,
  SIM_INSTALL_ING,
  SIM_INSTALL_FINISHED,
  SIM_VM_RUN,
  SIM_VM_DESKTOP,
  SIM_PREPARE,
  SIM_UPDATE_INSTALL_ING,
  SIM_UPDATE_INSTALL_FINISHED,
];

// 任务列表中 任务显示为‘准备中’的状态集合
export const SIM_STATUS_RUN = [
  SIM_PREPARING,
  SIM_DOWNLOAD_ING,
  SIM_DOWNLOAD_FINISHED,
  SIM_INSTALL_ING,
  SIM_INSTALL_FINISHED,
  SIM_VM_RUN,
  SIM_VM_DESKTOP,
  SIM_PREPARE,
  SIM_PREPARE_DONE,
  SIM_UPDATE_INSTALL_ING,
  SIM_UPDATE_INSTALL_FINISHED,
];

// 任务列表中 显示为‘环境准备错误’的状态集合
export const SIM_STATUS_ERROR = [
  SIM_DOWNLOAD_FAILED,
  SIM_INSTALL_FAILED,
  SIM_DOWNLOAD_CANCELED,
  SIM_VM_DESKTOP_FAILED,
  SIM_PREPARE_FAILED,
  SIM_UPDATE_INSTALL_FAILED,
];

// 模拟器是否已经安装
export const SIM_IS_INSTALLED_REQUEST = 'SIM_IS_INSTALLED_REQUEST';
export const SIM_IS_INSTALLED = 'SIM_IS_INSTALLED';
// 模拟器是否正在运行
export const SIM_IS_RUNNING_REQUEST = 'SIM_IS_RUNNING_REQUEST';
export const SIM_IS_RUNNING = 'SIM_IS_RUNNING';
// TV模式是否打开
export const SIM_ISVT_ENABLED_REQUEST = 'SIM_ISVT_ENABLED_REQUEST';
export const SIM_ISVT_ENABLED = 'SIM_ISVT_ENABLED';
// 模拟器下载进度 跟踪
export const SIM_UPDATE_DOWNLOAD_PROGRESS = 'SIM_UPDATE_DOWNLOAD_PROGRESS';
// 模拟器状态 跟踪
export const SIM_UPDATE_STATUS = 'SIM_UPDATE_STATUS';
// 选择是否下载模拟器弹框信息
export const SIM_POPUP_INFO = 'SIM_POPUP_INFO';
